module.exports = __webpack_public_path__ + "static/media/temp_1.c230d344.jpg";